export const IDENTITY_FAILURE = "IDENTITY_FAILURE";
export type IDENTITY_FAILURE = typeof IDENTITY_FAILURE;

export const IDENTITY_REQUEST = "IDENTITY_REQUEST";
export type IDENTITY_REQUEST = typeof IDENTITY_REQUEST;

export const IDENTITY_LOAD_SUCCESS = "IDENTITY_LOAD_SUCCESS";
export type IDENTITY_LOAD_SUCCESS = typeof IDENTITY_LOAD_SUCCESS;

export const IDENTITY_DELETE_SUCCESS = 'IDENTITY_DELETE_SUCCESS';
export type IDENTITY_DELETE_SUCCESS = typeof IDENTITY_DELETE_SUCCESS;

export const IDENTITY_CREATE_SUCCESS = 'IDENTITY_CREATE_SUCCESS';
export type IDENTITY_CREATE_SUCCESS = typeof IDENTITY_CREATE_SUCCESS;


// WEBPACK FOOTER //
// ./src/constants/identity.constants.ts